module.exports = __webpack_public_path__ + "static/media/Amanda M.de232afc.png";